<template>
	<div class="deposit" v-if="isLoaded">
		<div v-if="!isHost2Host">
			<div class="fields">
				<div class="fields__item">
					<PaymentSystems v-if="paymentTypes" :items="paymentTypes" :selected-type="selectedType"
						@set-type="selectType" />
				</div>
				<div class="fields__item field-input__label"
					v-if="isCryptoType && selectedType && selectedType.currency">
					<div class="field-input__label">
						1 {{ selectedType.title }} ≈ {{ $root.currency(selectedType.currency) }}
					</div>
				</div>
				<div class="fields__item" v-if="isCryptoType">
					<div class="fields__row">
						<div class="fields__item">
							<button @click="deposit" :disabled="!selectedType || disableBtn"
								:class="{'disabled':!selectedType || disableBtn}" class="btn deposit__action">
								Получить кошелёк
							</button>
						</div>
						<div class="fields__item field-input">
							<input autocomplete="off" class="field-input__input" placeholder="Введите промокод"
								type="text" v-model="promocode">
						</div>
					</div>
				</div>
				<div v-else class="fields__item fields__row">
					<div class="fields__item">
						<div class="field-input">
							<label class="field-input__label">Сумма
								<span v-if="selectedType">от {{ $root.currency(selectedType.min_amount) }} <span
										v-if="selectedType.max_amount"> до {{ $root.currency(selectedType.max_amount)
										}}</span></span>
								<span v-if="selectedType">
									<span> Комиссия: {{ selectedType.min_commission }}%</span>
									<div v-if="selectedType.min_commission">
										К оплате с учётом комиссии:
										<span class="font-weight-bold">
											{{ Math.round(amount) + (Math.round(amount) / 100 *
											selectedType.min_commission) }} ₽
										</span>
									</div>
								</span>
							</label>

							<input autocomplete="off" class="field-input__input" type="number"
								placeholder="Введите сумму" v-model="amount">

						</div>
					</div>

					<div class="fields__item field-input">
						<label class="field-input__label">Промокод</label>
						<input autocomplete="off" class="field-input__input" type="text" placeholder="Введите промокод"
							v-model="promocode">
					</div>
				</div>
				<div v-if="amountPresets" class="fields__item">
					<div class="warn-box">Для получения реквизитов попробуйте выбрать сумму из списка ниже
						<div class="field-input__presets">
							<button class="btn field-input__preset" v-for="preset in amountPresets" @click="amount = preset">{{preset}}</button>
						</div>
					</div>
				</div>
				<div class="fields__item">
					<vue-recaptcha class="sing-in__google-recaptcha" ref="recaptcha" :sitekey="$root.$reCaptchaSiteKey"
						@verify="onCaptchaVerified" @expired="onCaptchaExpired">
					</vue-recaptcha>
				</div>

				<div v-if="!isCryptoType" class="fields__item">
					<button @click="deposit" :disabled="!selectedType || disableBtn"
						:class="{'disabled':!selectedType || disableBtn}" class="btn deposit__action">
						Перейти к оплате
					</button>
				</div>

				<div class="fields__item warn-box">
					Не создавайте несколько заявок сразу, пополнение может не зачислиться. Если есть проблемы, пишите в
					<a :href="$root.$link.support" target="_blank"> техподдержку</a>
					<a class="btn warn-box__action" :href="$root.$link.support" target="_blank">Обратиться в
						техподдержку</a>
				</div>
			</div>

		</div>
		<div class="deposit__history" v-if="isHost2Host">
			<div class="fields__item warn-box" v-if="isCryptoType">
				Обязательно убедитесь, что вы отправляете на данный кошелек <span
					class="font-weight-bold">{{selectedType.title}}</span>
				<div>
					В случае ошибки ваши деньги могут будут утрачены безвозвратно
				</div>
				<div v-if="selectedType.min_amount" class="mt-5">
					<div>
						Минимальная сумма: <span class="font-weight-bold">{{selectedType.min_amount}}
							{{selectedType.title}}</span>
					</div>
					<div>
						Переводы меньше <span class="font-weight-bold">{{selectedType.min_amount}}
							{{selectedType.title}}</span> не поступят на баланс
					</div>
				</div>
			</div>

			<div class="fields__item" v-if="isCryptoType && selectedType && selectedType.currency">
				<div class="field-input__label">
					1 {{ selectedType.title }} ≈ {{ $root.currency(selectedType.currency) }}
				</div>
			</div>

			<div v-if="!isCryptoType" class="fields__item">
				Отправьте <span class="font-weight-bold">{{ $root.currency(paymentData.amount) }}</span> рублей на
				указанные ниже реквизиты
			</div>

			<div class="fields__item" v-if="paymentData.number">
				<div class="text-muted">Реквизиты</div>
				<CopyField :text="paymentData.number" :message="'Номер скопирован'" />
			</div>

			<div class="fields__item text-center" v-if="isCryptoType && paymentData.number && !isMob">
				<img :src="'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=' + paymentData.number" />
			</div>

			<div class="fields__item" v-if="paymentData.holder">
				<div class="text-muted">Получатель</div>
				<div>{{ paymentData.holder }}</div>
			</div>
			<div class="fields__item" v-if="paymentData.bank">
				<div class="text-muted">Банк</div>
				<div>{{ paymentData.bank_display_name ? paymentData.bank_display_name : paymentData.bank }}</div>
			</div>
			<div class="fields__item" v-if="paymentData.amount && !isCryptoType">
				<div class="text-muted">Сумма</div>
				<CopyField :text="paymentData.amount" :message="'Сумма скопирована'" />
			</div>
			<div class="fields__item">
				<button class="btn btn--block" @click="isHost2Host = false">Отменить</button>
			</div>
		</div>
		<div class="deposit__payments" v-if="payments.length">
			<div class="deposit__payments-title">История пополнения</div>
			<Payments :items="payments" />
		</div>

	</div>
</template>

<script>
    import Payments from "../blocks/Payments.vue";
	import PaymentSystems from "../blocks/PaymentSystems.vue";
	import CopyField from "../blocks/CopyField.vue";
	import breakpointsMixin from '../../mixins/breakpoints-mixin.vue';
	import VueRecaptcha from './../../components/googlerecaptcha/GoogleReCaptcha.vue';

	const PAYMENT_TYPE_URL = 'url';
    const PAYMENT_TYPE_H2H = 'h2h';
    export default {

		components: {
			CopyField,
			PaymentSystems,
			Payments,
			VueRecaptcha,
		},

		mixins: [
			breakpointsMixin
		],

		data() {
            return {
                amount: null,
                promocode: null,
                disableBtn: false,
                payments: [],
                paymentTypes: [],
                selectedType: null,
                isLoaded: false,
                isHost2Host: false,
                paymentData: null,
				gRecaptchaResponse: null,
            }
        },
        mounted() {
            this.getPaymentMethods();
            this.getPayments();
        },

		computed: {
			isCryptoType() {
				return (this.selectedType && this.selectedType.group_code === 'crypto') || (this.isTablet && !this.selectedType);
			},

			amountPresets() {
				if (this.amount && this.selectedType?.min_amount <= this.amount && this.selectedType?.max_amount >= this.amount) {
					let min = this.amount - 20 >= this.selectedType.min_amount;
					let max = this.amount + 20 <= this.selectedType.max_amount;
					return [this.randomInteger(min ? this.amount  -  20 : this.amount + 1, max ? this.amount  +  20: this.amount), this.randomInteger(min ? this.amount  -  20 : this.amount + 1, max ? this.amount  +  20: this.amount), this.randomInteger(min ? this.amount  -  20 : this.amount + 1, max ? this.amount  +  20: this.amount)]
				}
			}
		},

        methods: {
            deposit() {
                var amount = Math.round(this.amount);
                this.amount = amount;

                if (this.disableBtn) {
                    return;
				}
				
                if (!this.gRecaptchaResponse) {
                    return this.$toast.error('Необходимо пройти капчу');
				}
				
                if(!this.selectedType) {
                    return this.$toast.error('Выберите платежную систему');
                }

				if(this.isCryptoType) {
					this.amount = 5000;
				}

                if(this.amount > this.selectedType.max_amount) {
                    return this.$toast.error(`Максимальная сумма ${this.selectedType.max_amount}`);
                }

                if(this.amount < this.selectedType.min_amount) {
                    return this.$toast.error(`Минимальная сумма ${this.selectedType.min_amount}`);
                }

                this.disableBtn = true;

                this.$root.axios.post('/api/payments/create', {
                    amount: this.amount,
                    type_id: this.selectedType.id,
                    promocode: this.promocode,
					recaptcha: this.gRecaptchaResponse
                }).then(res => {
                    const data = res.data;

                    if (data.success) {
                        switch (data.details.type) {
                            case PAYMENT_TYPE_URL:
                                window.location.href = data.details.url;
                            break;
                        
                            case PAYMENT_TYPE_H2H:
                                this.isHost2Host = true;
                                this.paymentData = data.details;
                            break;
                        }
                    } else {
                        this.$toast.error(data.message);
						this.onCaptchaExpired();
                    }
                }).catch(error => {
                    error = this.$root.graphql.axiosGetError(error);
                    this.$toast.error(error);
					this.onCaptchaExpired();
                });

				this.disableBtn = false;
            },
            getPayments() {
                this.$root.axios.get('/api/payments/latest').then(res => {
                    this.payments = res.data;
                    this.isLoaded = true;
                });
            },
            getPaymentMethods() {
                this.$root.axios.get('/api/payments/methods').then(res => {
                    this.paymentTypes = res.data;  
                });
            },
            selectType(type) {
                this.selectedType = type;
            },
			onCaptchaVerified(response) {
				this.gRecaptchaResponse = response;
			},
			onCaptchaExpired() {
				this.$refs.recaptcha.reset()
			},
			randomInteger(min, max) {
				return Math.floor(min + Math.random() * (max + 1 - min));
			}
        },
        sockets: {
            payment_complete: function() {
                this.getPayments();
            }
        }
    }
</script>
